import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from "@mui/icons-material/Save";
import { Box, Button, Grid, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import LanguageData from "../../../configs/LanguageData.json";
import { useDispatch, useSelector } from "react-redux";
import { IState } from "../../../redux/reducers/rootReducers";
import CustomFormLabel from "../../common/form-label/CustomFormLabel ";
import CommonTextArea from "../../common/textarea/CommonTextarea";
import WhatsappSkeleton from "./WhatsappSkeleton";
import { returnFormValues } from "../../helpers/helperFunctions";
import { addNewTicket } from "../../../services/dashboard/dashboard.service";
import { getAllDAshboardData } from '../../../redux/actions/TicketsManagement/TicketsManagement';
import { triggerAppAlert } from "../../../redux/actions/SelfServicePortal/ContactAid/ContactAid";
import CommonContactDropDown from "../../../pages/new-ticket/LatestTicket/CommonContactDropDown";
import { getContactByIdAction } from "../../../redux/actions/ContactManagement/Contact";
import EffortField from '../../MobileComponents/MobileUtilities/EffortField';
import { convertToTimeSpan } from '../../../pages/new-ticket/AddUpdate';
import {getAllTickets } from "../../../redux/actions/TicketsManagement/TicketsManagement";

const RapidTicketsModal = memo(() => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const rapidTicket = useSelector((state: IState) => state?.TicketViewReducer?.rapidTicket);
     const FiltersVal: any = useSelector((state: IState) => state?.filtersTicketManagementReducer);
     const AllData = useSelector((state: IState) => state?.TicketsReducer?.allResponses);
    const statusList = useSelector(
        (state: IState) => state?.TicketsReducer?.allResponses?.ticketStatus || []
    );
//     console.log("statusList__",statusList);

    const currAgent = useSelector((state: IState) => state?.agentReducer?.loggedInAgent);
    const [isModalOpen, setIsModalOpen] = useState(false);

  // Temporary fix will add Different Api for this
    useEffect(() => {
        // if(statusList.length == 0){
            dispatch(getAllDAshboardData())
        // }
    },[])

useEffect(() => {
  const timer = setTimeout(() => {
    setIsModalOpen(rapidTicket);

    const minsTimer = setTimeout(() => {
      const minsInput = document.querySelector(
      '.rapid-ticket-modal input[name="mins"]'
      ) as HTMLInputElement | null;
    // adding Default 15 Minutes as Effort
      if (minsInput) {
        if (minsInput.value === "") {
          minsInput.value = "15";
        }
        clearInterval(minsTimer);
      }
    }, 50);
  }, 10);

  return () => clearTimeout(timer);
}, [rapidTicket]);

    const onCloseHandler = useCallback(() => {
        dispatch({
            type: "TOGGLE_RAPID_TICKET_MODAL",
            payload: false,
        })
    }, [])

    const onSubmit = (e: any) => {
        e.preventDefault();
        const data = returnFormValues(e.currentTarget);
        const { title, description, primaryContact,hours,mins} = data;

        if( !title || !description || !primaryContact ){
            dispatch(triggerAppAlert("Please fill all mandatory fields", "warning"));
            return;
        }
        const newStatus = statusList.find((status: any) => status.name === "New");

        if(!newStatus){
            dispatch(triggerAppAlert("User don't have role permission to perform this action, Please contact admin.", "warning"));
            return;
        }
        const getContactById = (resStatus: string, resData: any) => {
            if (resStatus === "0") {
//                 console.log("getContactById__", resData)
                
        const request: any = {
            "id": 0,
            "sourceCode": "Phone",
            "ticketLogs": {
                "contactId": +primaryContact,
                "title": title,
                "description": description,
                "sourceCode": "Phone",
                "statusId": newStatus.id,
                "ticketStatus": newStatus,
                "agentId": currAgent?.id,
                // "circulationListTO": contact?.email || "",
                "circulationListTO": resData.email,
                "groupId": currAgent?.defaultGroup?.groupId || null,
                "effort": convertToTimeSpan("",hours,mins)
            },
        }
//             console.log("request__",request)
        addNewTicket(request).then((res: any) => {
            dispatch(triggerAppAlert(`${LanguageData.TICKET_ADDED_SUCCESSFULLY}${res?.data?.id}`, "success"));
//             console.log("New Ticket Created: ", res);
            // dispatch(triggerAppAlert(`New Ticket Created : ${res.data.id} `, "success"));
            dispatch(getAllTickets(FiltersVal,AllData))
            onCloseHandler();
        }).catch((err: any) => {
            dispatch(triggerAppAlert("Failed to create ticket", "error"));
            console.error("Error in creating ticket: ", err);
        });
            }
        }

       if (primaryContact) {
            dispatch(getContactByIdAction(primaryContact, getContactById));
        }
    }

    const formSection = useMemo(() => {
        return (<>
        
            <Grid container spacing={2} sx={{pb:2}}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <CommonContactDropDown
                        callback={(e: any) => {
                            //   setContact(e);
                        }}
                        title="Choose Contact"
                        defaultValue={null}
                        // addonQuery="&isSelfServiceAccess=false"
                        isMandatory={true}
                      />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <CustomFormLabel
                        labelName={"Subject"}
                        isMandotary={true}
                    />
                    <CommonTextArea
                        multiline={false}
                        // onChange={onchangeInput}
                        name={"title"}
                    />
                </Grid>
            </Grid>
             

            <CustomFormLabel
                labelName={"Description"}
                isMandotary={true}
            />
            <CommonTextArea
                multiline={true}
                rows={8}
                // onChange={onchangeInput}
                name={'description'}
            />
             <Box sx={{my:2}} className='rapid-ticket-modal'>
            <EffortField />
            </Box>

        </>)
    }, [])

    const viewContent = useMemo(() => <>
        {rapidTicket &&
            <Box className={classes.popupHolder}>
                <Box className="modal-dialog">
                    <Box className="modal-content">
                        <Box className="modal-header">
                            <Typography variant="h6" className="txtCapitalize">
                                <span>Rapid logging</span>
                                &nbsp;&nbsp;
                            </Typography>
                            <Typography className="cursor-pointer" onClick={onCloseHandler}>
                                <CloseIcon className="cursor-pointer" />
                            </Typography>
                        </Box>
                        <Box onSubmit={onSubmit} component="form" className="p-1">
                            {isModalOpen ? <>
                                {formSection}
                                <Box className="text-center">
                                    <Button
                                        className={`${classes.btn} ${classes.btnCancel}`}
                                        variant="outlined"
                                        onClick={onCloseHandler}
                                    >
                                        <CancelIcon style={{ marginRight: "5px" }} />
                                        Cancel
                                    </Button>
                                    <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                    <Button
                                        className={`${classes.btn} ${classes.btnSubmit}`}
                                        variant="contained"
                                        type="submit"
                                    // onClick={onSubmit}
                                    >
                                        <SaveIcon style={{ marginRight: "5px" }} />
                                        Send
                                    </Button>
                                </Box>
                            </> : <>
                                <WhatsappSkeleton />
                            </>}

                        </Box>
                    </Box>
                </Box>
            </Box>
        }
    </>, [isModalOpen])
    return (<>
        {viewContent}
    </>)
})
export default RapidTicketsModal;
const useStyles = makeStyles(() =>
    createStyles({
        row: {
            display: "flex"
        },
        flxWrap: {
            flexWrap: "wrap",
        },
        popupHolder: {
            position: "fixed",
            top: 0,
            left: 0,
            background: "#0005",
            width: "100%",
            height: "100%",
            overflow: "hidden",
            zIndex: 1399,
            "& .modal-dialog": {
                display: "flex",
                height: '100%',
                justifyContent: "center",
                alignItems: "center",
            },
            "& .modal-header": {
                display: "flex",
                alignItems: "center",
                padding: "20px",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                paddingBottom: "10px"
            },
            "& .modal-body": {
                maxHeight: "calc(100vh - 200px)",
                overflowY: "scroll",
                padding: "0px"
            },
            "& .modal-body > div": {
                margin: "0 !important",
                maxWidth: "calc(100% - 15px)"
            },
            "& .modal-content": {
                background: "#fff",
                width: "100%",
                maxWidth: "1000px",
                borderRadius: "5px",
                //padding: "20px",
                "& img.Contactprofile": {
                    width: "calc(100% - 10px)",
                },
                "& img": {
                    objectFit: "cover"
                }
            }
        },
        btn: {
            margin: "10px",
            lineHeight: "24px",
            fontSize: "13px",
            fontWeight: 400,
            color: "#ffffff",
            padding: "5px",
            width: "100px",
            "@media screen and (max-width:980px)": {
                padding: "5px 9px",
                fontSize: "9px",
                width: "auto",
                lineHeight: "18px",
                minWidth: "auto",
                "& svg": {
                    height: ".6em",
                },
            },
        },
        btnCancel: {
            color: "#6989fa",
            width: "110px",
            backgroundColor: "white",
            border: "2px solid #6989fa",
            marginRight: "10px",
            "&:hover": {
                backgroundColor: "white",
            },
        },
        btnSubmit: {
            color: "#ffffff !important",
            minWidth: "110px !important",
            width: "auto",
            whiteSpace: 'nowrap',
            // backgroundColor: "#1976d2 !important",

        },
        cardTcktCount: {
            padding: "5px 10px",
            background: "#ffa000",
            display: "inline",
            lineHeight: "1",
            fontSize: "12px",
            position: "relative",
            "& .dots": {
                position: "absolute",
                width: "8px",
                height: "8px",
                background: '#fff',//mode.cardHeader,
                left: "-5px",
                borderRadius: "50%",
                top: "50%",
                transform: "translateY(-50%)",
            },
            "& .dots.dots-right": {
                left: "unset",
                right: "-5px",
            },
            "& .dots.whiteBG": {
                background: "#fff" //mode.whiteSolid
            },
        },
        textWithSpanTitle: {
            "& .title-txts": {
                lineHeight: '1.5',
                marginBottom: 10,
                fontSize: '13px',
                "& > span": {
                    display: 'block',
                    fontSize: '11px',
                    marginBottom: '2px',
                    lineHeight: '1',
                    color: "#5559"//mode.link,
                }
            }
        },
        txtWithLink: {
            fontSize: ".7em",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            "& span": {
                wordBreak: "break-all"
            },
            "& a": {
                fontSize: ".7em",
                textDecoration: "none",
                display: "inline-block",
                lineHeight: 1,
                "& svg": {
                    fontSize: "12px"
                }
            }
        }
    }))